enum clientDirectoryEndpoints {
  TABLEDATA = '/clients',
}
export default clientDirectoryEndpoints;
